import { localConfig } from './config.local';
import { Config } from './configType';
import { configByHost, configForUnitTests } from './environments';

export const devConfig = {
  // Use to temporary check pages behind KYC tier enforcement
  disabledKycEnforcer: false,
};

/**
 * When running unit test, application will be in this special state
 */
export const IS_TEST_ENVIRONMENT = process.env.NODE_ENV === 'test';

// export const IS_DEV_SERVER = import.meta.env.MODE === 'development';

// localConfig is available only after we modify it manually
//  - it's always `undefined` for CI builds
const config = IS_TEST_ENVIRONMENT
  ? configForUnitTests
  : localConfig || configByHost;

/**
 * All environments with DevBar enabled. Non-production
 * PREVIEW !
 */
export const IS_DEBUG_ENVIRONMENT =
  config?.env === 'staging' ||
  config?.env === 'test' ||
  config?.env === 'local';

/**
 * No chain selection for deposit/withdrawals. Skip to second screen.
 */
export const IS_KATANA_ONLY_CHAIN = false;

export const SHOW_DEBUG_PANELS = IS_DEBUG_ENVIRONMENT;
// Hide based on URL if needed (eg. for demo)
// && document.location.host !== 'exchange-preview-ikon-staging.kuma-dev.com';

if (!config) {
  // Critical setup problem: This will cause app to not render at all !
  throw new Error('Missing domain configuration. Check environment.ts');
}

window.globalConfig = config;

export default config as Config;

// const chainCodesMap = Object.entries(config.chains).reduce(
//   (map, [chainCode, chain]) => {
//     map[chain.chainId] = chainCode as any;
//     return map;
//   },
//   {} as { [chainId: number]: ChainsFromConfig }
// );

// export const getChainCodeByChainId = (chainId: number): ChainsFromConfig => {
//   const chain = chainCodesMap[chainId];
//   if (!chain) {
//     throw new Error('Unexpected chain id conversion problem');
//   }
//   return chain;
// };

// export const getWidgetsDomain = () =>
//   typeof config.widgetsSubdomain === 'string'
//     ? config.widgetsSubdomain
//     : config.widgetsSubdomain === true
//     ? 'https://widgets-' + window.location.host
//     : window.location.origin;
